module.exports = __webpack_public_path__ + "img/logo.56a5db43.png";